<template>

    <v-row class="fill-height">
        <v-col>
            <v-card>
                <v-card-title>
                    <v-icon left>mdi-factory</v-icon>
                    Fornecedores
                    <v-spacer></v-spacer>
                    <v-text-field
                        v-model="paginationOptions.search"
                        class="mr-3"
                        append-icon="mdi-magnify"
                        label="Buscar"
                        placeholder="Informe o Nome do Fornecedor"
                        single-line
                        hide-details
                        @keydown="buscar()"
                        @click:append="buscar()"
                    ></v-text-field>
                    <v-spacer></v-spacer>
                    <v-switch
                        v-model="suppliers.active"
                        :label=" `Exibindo ${suppliers.active? 'Ativos': 'Inativos'}`"
                        single-line
                        hide-details
                        class="mr-3"
                        style="width: 200px"
                        @change="buscar()"
                    ></v-switch>
                    <v-btn
                        color="#3D1159"
                        dark
                        :to="{ name: 'supplierCreate', params: {} }"
                    >
                        <v-icon left>mdi-plus</v-icon>
                        Adicionar
                    </v-btn>
                </v-card-title>
                <v-alert type="warning" outlined v-show="!suppliers"> Nenhum Fornecedor Encontrado</v-alert>
                <v-data-table
                    v-model="selected"
                    :headers="headers"
                    :items="filteredSuppliersItems()"
                    :options.sync="options"
                    item-key="id"
                    :search.sync="paginationOptions.search"
                    class="elevation-1"
                    v-show="suppliers"
                    :footer-props="{
                        'items-per-page-options': [10, 25, 50, 75, 100]
                      }"
                >

                    <template v-slot:item.value="{ item }">
                        {{ item.value | money }}
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    icon
                                    class="btn-lyndus"
                                    v-bind="attrs"
                                    v-on="on"
                                    :to="{ name: 'supplier', params: { id: item.id } }"
                                >
                                    <v-icon>mdi-eye</v-icon>
                                </v-btn>
                            </template>
                            <span>Visualizar</span>
                        </v-tooltip>
                    </template>
                    
                    
                </v-data-table>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import {mapGetters} from "vuex";
import store from "@/store";
import {mask} from "vue-the-mask";

import {SUPPLIER_SEARCH} from "@/store/actions/supplier.type";
import {SET_SUPPLIER_PAGINATION, SUPPLIER_RESET_STATE} from "@/store/mutations/supplier.type";

export default {
    name: "ListSupplier",
    directives: {mask},
    props: {
        source: String
    },

    components: {},
    async beforeRouteUpdate(to, from, next) {
        // Reset state if user goes from /editor/:id to /editor
        // The component is not recreated so we use to hook to reset the state.
        await store.commit(SUPPLIER_RESET_STATE);
        return next();
    },
    async beforeRouteEnter(to, from, next) {
        Promise.all([
            store.dispatch(SUPPLIER_RESET_STATE),
            await store.dispatch(SUPPLIER_SEARCH)
        ]).then(() => {
            next();
        });
    },
    async beforeDestroy() {
        if(!this.$route.path.includes('/suppliers')){
            localStorage.removeItem('suppliersOptions')
            localStorage.removeItem('supplierPaginationOptions')
        }
    },
    data: () => ({
        //Lista de Usuários
        pagination: {
            sortBy: "name"
        },
        options:{},
        paginationOptions: {},
        selected: [],
        headers: [
            {
                text: "Razão Social",
                align: "left",
                value: "name"
            },
            {text: "CNPJ", value: "cnpj"},
            {text: "Telefone", value: "phone"},
            {text: "Representante", value: "representative"},
            // {text: "Observação", value: "obs"},
            //{text: "Endereço", value: "address"},
            {text: "Visualizar", value: "actions", sortable: false}
        ],


    }),
    methods: {
        //Methods Lista Usuarios
        toggleAll() {
            if (this.selected.length) this.selected = [];
            else this.selected = this.dados.slice();
        },
        changeSort(column) {
            if (this.pagination.sortBy === column) {
                this.pagination.descending = !this.pagination.descending;
            } else {
                this.pagination.sortBy = column;
                this.pagination.descending = false;
            }
        },
        buscar() {
            const {sortBy, sortDesc, itemsPerPage, page} = this.options
            this.supplierPagination.search = this.paginationOptions.search

            store.commit(SET_SUPPLIER_PAGINATION, {
                page: page,
                itemsPerPage: itemsPerPage,
                orderBy: sortBy,
                sortDesc: sortDesc[0]
            })
            store.dispatch(SUPPLIER_SEARCH);
        },
        filteredSuppliersItems() { 
            const items = this.suppliers.items
            const search = this.supplierPagination.search ? this.supplierPagination.search.toLowerCase() : "" 
            if(search){
                this.options.itemsPerPage = this.suppliers.totalItems
                this.options.page = 1
                const exactMatches = [];
                const partialMatches = [];

                items.forEach(item => {
                    const itemValues = Object.values(item).map(value => String(value).toLowerCase());
                    const isExactMatch = itemValues.some(value => value.startsWith(search));
                    const isPartialMatch = itemValues.some(value => value.includes(search));
                    
                    if (isExactMatch) {
                        exactMatches.push(item);
                    } else if (isPartialMatch) {
                        partialMatches.push(item);
                    }
                });

                return [...exactMatches,...partialMatches];
            }
            else {
                if(this.options.itemsPerPage == this.suppliers.totalItems){
                    this.options.itemsPerPage = 10
                }
                return items;
            } 
        }
    },
    mounted() {
        if (localStorage.getItem('suppliersOptions')){
            this.options = JSON.parse(localStorage.getItem('suppliersOptions'))
        }
        if (localStorage.getItem('supplierPaginationOptions')){
            this.paginationOptions = JSON.parse(localStorage.getItem('supplierPaginationOptions'))
        }
    },
    watch: {
        options: {
            handler(newOptions) {
                this.buscar()
                const parsed = JSON.stringify(newOptions)
                localStorage.setItem('suppliersOptions', parsed)
            },
            deep: true,
        },
        paginationOptions: {
            handler(newSearch) {
                this.buscar()
                const parsed = JSON.stringify(newSearch)
                localStorage.setItem('supplierPaginationOptions', parsed)
            },
            deep: true,
        }
    },
    computed: {
        // ...mapState({
        //   courses: state => state.
        // })

        ...mapGetters(["suppliers", "checkUsers", "supplierPagination"])
    },
    
};
</script>
